<template>
  <hic-dialog :title="title" :visible="visible" @close="cancel" width="60%" top="10vh">
    
     <template slot="title" style="text-align: center;">
       <el-tag style="float: left;">已完成</el-tag>
       <span>手术详情</span>
    </template>

    <el-main style="padding: 0 10px" class="top-pad">
      <el-row type="flex" justify="space-between" class="bg">
        <div>{{ entity.name || '测试' }}</div>
        <div>{{ entity.gender || '测试' }}</div>
        <div>{{ entity.birthday | age }}</div>
        <div>{{ entity.archiveNo || '测试' }}</div>
        <div>主要诊断: {{ entity.zyzd || '测试' }}</div>
        <div>住院科室: {{ entity.zyks || '测试' }}</div>
        <div>入院时间: {{ entity.rysj || '测试' }}</div>
      </el-row>
      <el-descriptions title="手术申请">
        <el-descriptions-item label="手术编码">88.656</el-descriptions-item>
        <el-descriptions-item label="手术名称">胆囊切除</el-descriptions-item>
        <el-descriptions-item label="预约时间">2020-01-25 10:58</el-descriptions-item>
        <el-descriptions-item label="术前诊断" :span="24">术前诊断术前诊断术前诊断</el-descriptions-item>
        <el-descriptions-item label="手术室">
          <el-tag size="small">一号手术室</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="手术类别">普通</el-descriptions-item>
        <el-descriptions-item label="麻醉方式">惊喜麻醉</el-descriptions-item>
        <el-descriptions-item label="切口愈合等级">静吸麻醉</el-descriptions-item>
        <el-descriptions-item label="手术级别">一级</el-descriptions-item>
        <el-descriptions-item label="手术部位">腹部</el-descriptions-item>

        <el-descriptions-item label="主刀医师">张医生</el-descriptions-item>
        <el-descriptions-item label="第一助手">张医生</el-descriptions-item>
        <el-descriptions-item label="第二助手">张医生</el-descriptions-item>
        <el-descriptions-item label="第三助手">张医生</el-descriptions-item>
        <el-descriptions-item label="第四助手">张医生</el-descriptions-item>

        <el-descriptions-item label="HSsAg">阴性</el-descriptions-item>
        <el-descriptions-item label="抗-HCV">张医生</el-descriptions-item>
        <el-descriptions-item label="抗-HIV">阴性</el-descriptions-item>
        <el-descriptions-item label="梅毒">无</el-descriptions-item>
        <el-descriptions-item label="血型">o型</el-descriptions-item>
        <el-descriptions-item label="备注" :span="24">备注备注备注备注不</el-descriptions-item>
      </el-descriptions>

      <el-collapse value="1">
        <el-collapse-item title="手术信息" name="1">
          <el-descriptions>
            <el-descriptions-item label="麻醉医师">88.656</el-descriptions-item>
            <el-descriptions-item label="手术开始时间">2020-01-25 10:58</el-descriptions-item>
            <el-descriptions-item label="手术结束时间">2020-01-25 10:58</el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
      </el-collapse>

    </el-main>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="$emit('update:visible', false)" class="left-pad">提交</el-button>
    </template>
    </hic-dialog>
 
</template>

<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  components: {},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {};
      },
    },
    visible: Boolean,
    title: String,
  },
  data() {
    return {
      checkedQZ: false,
      checked: false,
      detailValue: {},
      rules: {
        // amount: [
        //   { required: true, message: "请输入预交金额", trigger: "blur" },],
        // payWay: [
        //   { required: true, message: "请选择支付方式", trigger: "change" },
        // ],
        // zpNo: [{ required: true, message: "请输入支票号", trigger: "blur" }],
        // zpBank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        // payerName: [{ required: true, message: "请输入交款人", trigger: "blur" }],
        // payerPhone: [
        //   { required: true, message: "请输入交款人联系方式", trigger: "blur" },
        //   { validator: ValidatePhone, trigger: "blur" }
        // ],
        // qzAmount:[{ required: true, message: "请输入可欠账额度", trigger: "blur" },],
        // qzEndDate:[{ required: true, message: "请选择欠账截止日期", trigger: "change" }]
      },
      card: {
        cardType: 'ipNo',
        cardNo: 'ip0000001', //
      },
      meta: {
        loading: false,
        showOper: false,
        content: false,
        showPayment: false,
      },
      reason: '',
      payParams: {},
    };
  },
  computed: {
    ...mapGetters(['dict', 'getDict', 'Enum', 'dictEnum', 'user', 'permission']),
  },
  filters: {},
  watch: {},
  mounted() {},
  methods: {
    async queryPatient() {},
    lookHistory() {
      this.meta.showOper = true;
    },

    genderFlter(v) {
      let info = this.dict.Gender.find(item => {
        return v == item.code;
      });
      return '';
    },
    submit(type) {},

    addCounts(id) {},
    cancel() {
      this.$emit('update:visible', false);
    },
    addFloat(num1, num2) {},
  },
};
</script>

<style scoped>
.redaK {
  background-color: #909399;
}

.tx-r {
  text-align: right;
}

.tx-l {
  text-align: left;
}

.tx-c {
  text-align: center;
}

.pall10p {
  padding: 10px;
}

.patientBox {
  height: 5rem;
  margin-bottom: 2rem;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.ztitle {
  margin-top: 10px;
  color: #66b1ff;
}

.inputnw .el-input {
  width: 4rem !important;
}

.inputDelW {
  width: 12rem;
}

.el-form--inline .el-form-item {
  margin-right: 0px;
}
</style>
<style>
.bg {
  background: #cccccc;
  padding: 1.5rem 1rem;
}
</style>
